import { render } from "./AbrofSubscribtion.vue?vue&type=template&id=25f251d4"
import script from "./AbrofSubscribtion.vue?vue&type=script&lang=js"
export * from "./AbrofSubscribtion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__